import React from 'react'
import EmptySearch from './images/search.svg?inline'

export default function EmptyState() {
  return <EmptySearch />
}
